import { Chip, createTheme } from '@material-ui/core';
import { convertStringWday, saveTime2ViewTime } from '../util/TimeTableUtil';

const TimeItem = ({ time, edit = false, onDelete }) => {
    return (
        <div className='time-item-chip'>
            {edit ? (
                <Chip
                    // color='primary'
                    variant='outlined'
                    size='small'
                    label={`(${convertStringWday(time.weekdayCd)}) ${saveTime2ViewTime(
                        time.bgnTime,
                    )}~${saveTime2ViewTime(time.endTime)}`}
                    onDelete={() => onDelete(time)}
                />
            ) : (
                <Chip
                    // color='primary'
                    variant='outlined'
                    size='small'
                    label={`(${convertStringWday(time.weekdayCd)}) ${saveTime2ViewTime(
                        time.bgnTime,
                    )}~${saveTime2ViewTime(time.endTime)}`}
                />
            )}
        </div>
    );
};

export default TimeItem;
